<template>
    <div class="borrowDetailsBox">
        <Box title="计量检测详情">
            <div class="equipment box">
                <p class="title">设备信息</p>
                <div class="equipment-details">
                    <img src="@/assets/img/Icon_1.png" />
                    <div>
                        <div>
                            <p>资产名称：</p>
                            <p>资产编号：</p>
                            <p>规格型号：</p>
                            <p>使用科室:</p>
                        </div>
                        <div>
                            <p class="ellipsis">{{ equipment.SBMC }}</p>
                            <p class="ellipsis">{{ equipment.SBBH }}</p>
                            <p class="ellipsis">{{ equipment.GGXH }}</p>
                            <p class="ellipsis">{{ parentData.KSMC }}</p>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="ellipsis">生产厂家：{{ parentData.SBCJ }}</div>
                </div>
            </div>
            <div class="borrow box">
                <p class="title">计量信息</p>
                <Field title="检测费用" :action='true' :text="MeteringInfo.JLFY" type="number" name='number'
                    @onMessage='e=>MeteringInfo.JLFY=e' />
                <Field title="证书编号" :text="MeteringInfo.ZSBH" type="input" placeholder="请输入证书编号"
                    @onMessage='e=>MeteringInfo.ZSBH=e' />

                <Field title="检测机构" placeholder='请选择' :text="MeteringInfo.JDJGMC" @manuconfirm="
                         (MeteringInfo.JDJG = arguments[0].a),
                           (MeteringInfo.JDJGMC = arguments[0].b)
                       " type='manufacturer' name='maintain' />

                <Field title="检测人" type="input" :text="MeteringInfo.JDJGJDR" placeholder="请输入检测人"
                    @onMessage='e=>MeteringInfo.JDJGJDR=e' />

                <Field title="检测结果" :tabSelected="MeteringInfo.JDJL"
                    @onMessage="(value) => (MeteringInfo.JDJL = value.id)" :data="[
            { id: '1', name: '合格' },
            { id: '0', name: '不合格' },
          ]" type="teb" />


                <Field title="检测时间" :text="JLSJ" type="calendar" :DateMax="maxDate" @onMessage="x=>JLSJ=x" />

                <Field title="检测周期" type="dropdown" placeholder="请选择" :data="JCZQ" :text="JCZQName" @manuconfirm="
                  (JCZQId = arguments[0].id), (JCZQName = arguments[0].name)
                " />

                <Field title="检测有效期" :text="GMSJ" type="calendar" :DateMax="maxDate" @onMessage="x=>GMSJ=x" />



                <Field title="下次检测" :text="GMSJ" type="calendar" :DateMax="maxDate" @onMessage="x=>GMSJ=x" />

                <Field title="审核人" name="personnel" :text="MeteringInfo.SHRMC" @manuconfirm="
            (MeteringInfo.SHR = arguments[0].a),
              (MeteringInfo.SHRMC = arguments[0].b)
          " type="manufacturer" />

                <Field title="负责人" name="personnel" :text="MeteringInfo.FZRMC" @manuconfirm="
            (MeteringInfo.FZR = arguments[0].a),
              (MeteringInfo.FZRMC = arguments[0].b)
          " type="manufacturer" />

                <Field title="批准人" type="input" :text="MeteringInfo.PZR" placeholder="请输入批准人"
                    @onMessage='e=>MeteringInfo.PZR=e' />

                <Field title="核验员" type="input" :text="MeteringInfo.HYY" placeholder="请输入核验员"
                    @onMessage='e=>MeteringInfo.HYY=e' />

                <Field title="校准员" type="input" :text="MeteringInfo.JZY" placeholder="请输入校准员"
                    @onMessage='e=>MeteringInfo.JZY=e' />


                <Field title="计量类型" :tabSelected="MeteringInfo.JLLX"
                    @onMessage="(value) => (MeteringInfo.JLLX = value.id)" :data="[
            { id: '0', name: '院内' },
            { id: '1', name: '院外' },
          ]" type="teb" />

            </div>
            <div class="explain box">
                <p class="title">备注</p>
                <textarea type="text" placeholder="请输入备注内容" cols="3" v-model="MeteringInfo.BZ" />
            </div>
            <div class="imgBox">
                <ImgModule upload :img="ImgList" title="图片" :deletable='ImgState' :disabled='!ImgState'
                    @afterRead="afterRead(arguments[0])" @deleteImg="deleteImg(arguments[0])" />
            </div>
            <div :class="(BtnUpdateState&&BtnSaveState)?'itemBottomBox2':'itemBottomBox2'">
                <div v-if="BtnUpdateState" @click="upload">保存</div>
                <div v-if='BtnSaveState' @click="Submit">提交</div>
            </div>
        </Box>
    </div>
</template>

<script>
    import Box from "@/components/commonBox/commonBox";
    import ImgModule from "../../components/imgModule/imgModule";
    import Field from "@/components/field/field";
    import {
        Toast,
        ImagePreview
    } from "vant";

    export default {
        name: "MeteringDetail",
        data() {
            return {
                parentData: this.$route.params.item,
                ImgState: this.$route.params.ImgState,
                selectIndex: 0,
                equipment: {}, //    设备信息
                MeteringInfo: {
                    //计量信息
                    JLFY: null,
                    JDJL: "0",
                    JLLX: "0",
                    GMSJ: null,
                },
                PostMerteringModel: {},
                JCZQ: [{
                        id: 0.5,
                        name: "半年"
                    },
                    {
                        id: 1,
                        name: "1年"
                    },
                    {
                        id: 2,
                        name: "2年"
                    },
                    {
                        id: 3,
                        name: "3年"
                    },
                    {
                        id: 4,
                        name: "4年"
                    },
                    {
                        id: 5,
                        name: "5年"
                    },
                    {
                        id: 10,
                        name: "10年"
                    },
                ],
                BtnUpdateState: this.$route.params.BtnUpdateState,
                BtnSaveState: this.$route.params.BtnSaveState,
                JCZQId: null, //检测周期Id
                JCZQName: null, //检测周期Name
                JLSJ: null, //检测日期
                GMSJ: null, //下次检测日期
                ChoiceJLSJ: "",
                maxDate: new Date("2050-12-31"),
                ImgDisabale: false,
                ImgList: [],
            };
        },
        components: {
            Box,
            Field,
            ImgModule,
        },
        beforeDestroy() {
           this.$Bus.$off('YSRKDelete');
        },
        mounted() {
            this.loadPJDefault();
        },
        methods: {
            Submit() { //提交
                this.$Dialog.confirm({
                    message: "提交后无法修改,请确保信息保存完成?",
                }).then(() => {
                    this.$get('api/Metering/UpdateJLZT', {
                        JCBH: this.parentData.JCBH
                    }).then(result => {
                        result.Status ? this.$Toast({
                            message: result.Msg,
                            duration: 1500,
                            onClose: () => {
                                this.$router.back()
                            }
                        }) : this.$Toast(result.Msg);
                    })
                }).catch(() => {});
            },
            save() { //再次保存
                if (!this.MeteringInfo.JLFY) {
                    this.$Toast('计量费用不能为空，请输入!')
                    this.$scrollscreen('.commonBox', 'start');
                    return false
                }
                this.$post("api/Metering/SaveMetering", {
                    SBBH: this.equipment.SBBH,
                    HH: this.parentData.HH,

                    ZSBH: this.MeteringInfo.ZSBH,
                    JLSJ: this.JLSJ,
                    GMSJ: this.GMSJ,
                    GGXH: this.equipment.GGXH,
                    ZZZ: this.equipment.ZZZ,
                    BH: this.parentData.BH, //出厂编号
                    SYKS: this.equipment.SYKS,
                    ZGR: this.MeteringInfo.FZR,
                    SHR: this.MeteringInfo.SHR,
                    JDR: this.MeteringInfo.DXTXR,
                    JDJL: this.MeteringInfo.JDJL,
                    JLZT: '0',
                    BZ: this.MeteringInfo.BZ,
                    JLFY: this.MeteringInfo.JLFY,
                    SBMC: this.equipment.SBMC,
                    JDJG: this.MeteringInfo.JDJG,
                    XCJCSJ: this.MeteringInfo.GMSJ,
                    SYNCFLAG: 0,
                    DXSJ: this.MeteringInfo.DXSJ,
                    JDXQ: this.JCZQId,
                    DXKG: this.MeteringInfo.DXKG,
                    JDJGJDR: this.MeteringInfo.JDJGJDR,
                    JCBH: this.parentData.JCBH,
                    JLLX: this.MeteringInfo.JLLX,
                    JZY: this.MeteringInfo.JZY||"",
                    PZR: this.MeteringInfo.PZR||"",
                    HYY: this.MeteringInfo.HYY||"",
                    XCJCSJ: this.GMSJ,
                }).then((result) => {
                    if (result.Status) {
                        this.$Toast({
                            message: '计量信息保存成功!',
                            duration: 2000,
                            onClose: () => {
                                // JLZT=='0'?'':this.$router.back()
                            }
                        });
                    } else this.$Toast(result.Msg);
                });
            },
            upload() { //保存
                if (!this.MeteringInfo.JLFY) {
                    this.$Toast('计量费用不能为空，请输入!')
                    this.$scrollscreen('.commonBox', 'start');
                    return false
                }
                if (!this.parentData.JCBH) {
                    this.PostMerteringModel.JCBH = this.parentData.JCBH ? this.parentData.JCBH : null;
                    this.PostMerteringModel.row = 1;
                    this.PostMerteringModel.JLLX = this.MeteringInfo.JLLX;
                    this.PostMerteringModel.HH = this.parentData.HH;
                    this.PostMerteringModel.SBBH = this.equipment.SBBH;
                    this.PostMerteringModel.ZSBH = this.MeteringInfo.ZSBH;
                    this.PostMerteringModel.SBMC = this.equipment.SBMC;
                    this.PostMerteringModel.JDJL = this.MeteringInfo.JDJL;
                    this.PostMerteringModel.JLZT = 0;
                    this.PostMerteringModel.JLFY = this.MeteringInfo.JLFY;
                    this.PostMerteringModel.SYKS = this.equipment.SYKS;
                    this.PostMerteringModel.KSMC = this.equipment.KSMC;
                    this.PostMerteringModel.JLSJ = this.JLSJ;
                    this.PostMerteringModel.GMSJ = this.GMSJ;
                    this.PostMerteringModel.JDR = this.MeteringInfo.DXTXR;
                    //this.PostMerteringModel.XM = this.MeteringInfo.DXTXRMC;
                    this.PostMerteringModel.JDJG = this.MeteringInfo.JDJG;
                    this.PostMerteringModel.JDJGMC = this.MeteringInfo.JDJGMC;
                    this.PostMerteringModel.BZ = this.MeteringInfo.BZ;
                    this.PostMerteringModel.SYNCFLAG = 0;
                    this.PostMerteringModel.ZZZ = this.equipment.ZZZ;
                    this.PostMerteringModel.BH = this.parentData.BH, //出厂编号
                        this.PostMerteringModel.ZGR = this.MeteringInfo.FZR;
                    this.PostMerteringModel.SHR = this.MeteringInfo.SHR;
                    this.PostMerteringModel.JDJGJDR = this.MeteringInfo.JDJGJDR;
                    this.PostMerteringModel.JDXQ = this.JCZQId;
                    this.PostMerteringModel.DXKG = this.MeteringInfo.DXSJ;
                    this.PostMerteringModel.XCJCSJ = this.GMSJ;
                    this.PostMerteringModel.PZR=this.MeteringInfo.PZR||"";
                    this.PostMerteringModel.JZY=this.MeteringInfo.JZY||"";
                    this.PostMerteringModel.HYY=this.MeteringInfo.HYY||"";
                    this.UploadAxios(this.PostMerteringModel);
                } else this.save();
            },
            loadPJDefault() {
                //请求获取计量信息
                if (!this.parentData.JCBH) {
                    this.saveBtn = false;
                    this.ImgDisabale = true;
                    var _this = this;
                    _this.$axios.all([_this.$get('api/Metering/MeteringDetail', {
                        SBBH: _this.parentData.SBBH,
                        HH: _this.parentData.HH,
                        Store: _this.$UserInfo.StoreCode,
                    }), _this.$get('api/Metering/GetMeteringImg', {
                        SBBH: _this.parentData.SBBH,
                        JCBH: '',
                        STORE: _this.$UserInfo.StoreCode,
                    })]).then(_this.$axios.spread(function(result, result2) {
                        //数据部分
                        _this.equipment = result.model;
                        _this.equipment.SCCJMC = _this.equipment.ZZZMC;
                        _this.MeteringInfo.ZSBH = result.model.ZSBH; //证书编号
                        _this.MeteringInfo.JDJGMC = result.JDJGMC; //检定机构名称
                        _this.MeteringInfo.JDJG = result.model.JDJG; //检定机构
                        _this.JLSJ = _this.$route.params.PageState ? _this.$format(new Date(),
                            'YYYY-MM-DD') : result.model.JLSJ; //计量日期
                        _this.MeteringInfo.SHR = result.model.SHR; //审核人
                        _this.MeteringInfo.SHRMC = result.SHRMC; //审核人姓名
                        _this.MeteringInfo.FZR = result.model.ZGR; //负责人
                        _this.MeteringInfo.FZRMC = result.ZGRMC; //负责人姓名
                        _this.MeteringInfo.DXTXR = result.model.JDR; //短信提醒人
                        //this.MeteringInfo.DXTXRMC = result.JDRMC; //短信提醒人姓名
                        _this.GMSJ = result.model.GMSJ; //到期时间
                        _this.MeteringInfo.JDJL = "1"; //检定结果 默认为合格
                        _this.MeteringInfo.JLLX =
                            result.model.JLLX == undefined ? "0" : result.model.JLLX; //计量类型 0院内 1院外
                        _this.MeteringInfo.JDXQ = result.model.JDXQ; //检测周期
                        _this.MeteringInfo.JLFY = result.model.JLFY ? result.model.JLFY : null; //计量费用
                        _this.MeteringInfo.DXSJ = result.model.DXSJ; //短信时间
                        _this.MeteringInfo.BZ = result.model.BZ; //备注
                        _this.MeteringInfo.JDJGJDR = ""; //检定机构检定人
                        _this.JCZQId = result.model.JDXQ; //计量周期

                        _this.JCZQName = _this.JCZQ.find(x => x.id == _this.JCZQId).name;

                        //附件部分
                        if (result2.TPList.length > 0 && !_this.$route.params.PageState) {
                            _this.ImgList = result2.TPList.map(x => {
                                return {
                                    DAMC: x.DAMC,
                                    DABH: x.DABH,
                                    DALJ: x.DALJ,
                                    DAMC: x.DAMC,
                                    url: x.RePath,
                                }
                            });
                            _this.$Bus.$emit('YSRKDelete', _this.ImgList)
                        }
                    }))
                } else {
                    if (this.parentData.JLZT == "1") {
                        this.saveBtn = false;
                        this.submitBtn = false;
                        this.ImgDisabale = true;
                    }
                    const _this = this;
                    _this.$axios.all([_this.$get('api/Metering/MeteringEdDetail', {
                        Store: _this.$UserInfo.StoreCode,
                        JCBH: _this.parentData.JCBH,
                    }), _this.$get('api/Metering/GetMeteringImg', {
                        SBBH: _this.parentData.SBBH,
                        JCBH: _this.parentData.JCBH,
                        STORE: _this.$UserInfo.StoreCode,
                    })]).then(_this.$axios.spread(function(result1, result2) {
                        try {
                            //数据部分
                            _this.equipment = result1.Meterings[0];
                            _this.MeteringInfo = result1.Meterings[0];
                            _this.equipment.GGXH = _this.equipment.SBXH;
                            _this.MeteringInfo.SHR = _this.MeteringInfo.SHR; //审核人
                            _this.MeteringInfo.SHRMC = _this.MeteringInfo.SHRXM; //审核人姓名
                            _this.MeteringInfo.FZR = _this.MeteringInfo.ZGR; //负责人
                            _this.MeteringInfo.FZRMC = _this.MeteringInfo.ZGRXM; //负责人姓名
                            _this.MeteringInfo.DXTXR = _this.MeteringInfo.JDR; //短信提醒人
                            _this.JCZQId = result1.Meterings[0].JDXQ;
                            _this.JLSJ = _this.equipment.JLSJ;
                            _this.GMSJ = _this.equipment.GMSJ;
                            _this.JCZQName = _this.JCZQ.find(x => x.id == _this.JCZQId).name;
                            //附件部分
                            if (result2.TPList.length > 0) {
                                _this.ImgList = result2.TPList.map(x => {
                                    return {
                                        DAMC: x.DAMC,
                                        DABH: x.DABH,
                                        DALJ: x.DALJ,
                                        DAMC: x.DAMC,
                                        url: x.RePath,
                                    }
                                });
                                _this.$Bus.$emit('YSRKDelete', _this.ImgList)
                            }
                        } catch (e) {
                            _this.$Toast('数据异常,请稍后再试!');
                        }

                    }))
                }
            },
            UploadAxios(model) { //保存方法
                this.$post("api/Metering/MeteringSubmit", {
                    GKHM: this.$UserInfo.UserId,
                    model,
                }).then((result) => {
                    if (result.Status) {
                        this.$Toast({
                            message: result.Msg,
                            duration: 1500,
                            onClose: () => {
                                this.$router.back()
                            }
                        });
                    } else this.$Toast(result.Msg);
                });
            },
            afterRead(obj) {
                //上传图片
                let ImgList = [];
                if (obj instanceof Array) {
                    let that = this;
                    obj.forEach(function(item, index) {
                        ImgList.push(item);
                    });
                } else ImgList.push(obj);
                this.UploadImg(ImgList);
            },
            UploadImg(ImgList) {
                //图片上传
                let ImgArray = [];
                ImgList.map((x) => {
                    x.content ?
                        ImgArray.push({
                            Content: x.content,
                            Name: x.file.name.replaceAll(',', '').replaceAll('=', '').replaceAll('&', '')
                                .replaceAll('+', '')
                        }) :
                        "";
                });
                this.$post("api/Metering/UploadImg", {
                    JCBH: this.parentData.JCBH ? this.parentData.JCBH : '',
                    ZHXGR: this.$UserInfo.UserId,
                    SBBH: this.equipment.SBBH,
                    BaseStrList: ImgArray,
                }).then((result) => {
                    if (result.Status) {
                        this.$Toast({
                            message: result.Msg,
                            duration: 1500,
                            onClose: () => {
                           this.GetMeteringImg(); //计划执行不加载其他图片，记录修改或查看才加载
                            }
                        });
                    } else this.$Toast(result.Msg);
                });
            },
            GetMeteringImg() {
                this.$get('api/Metering/GetMeteringImg', {
                    SBBH: this.parentData.SBBH,
                    JCBH: this.parentData.JCBH ? this.parentData.JCBH : '',
                    STORE: this.$UserInfo.StoreCode,
                }).then(result => {
                    if (result.TPList.length > 0) {
                        this.ImgList = result.TPList.map(x => {
                            return {
                                DAMC: x.DAMC,
                                DABH: x.DABH,
                                DALJ: x.DALJ,
                                DAMC: x.DAMC,
                                url: x.RePath,
                            }
                        });
                        this.$Bus.$emit('YSRKDelete', this.ImgList)
                    }
                })
            },
            deleteImg(obj) { //删除图片
            console.log(obj);
                this.$Dialog.confirm({
                        message: "确认删除?",
                    }).then(() => {
                        this.$get('api/Metering/DelImage', {
                            SBBH: this.parentData.SBBH,
                            DABH: obj.DABH,
                            DAMC: obj.DAMC,
                            DALJ: obj.DALJ
                        }).then(result => {
                            if (result.Status) {
                                this.ImgList.splice(this.ImgList.findIndex((x) => x.DABH === obj.DABH), 1);
                                this.$Bus.$emit('YSRKDelete', this.ImgList);
                                this.$Toast(result.Msg);
                            }
                        })
                    })
                    .catch(() => {});
            },
        },
        watch: {
            JLSJ(newdata, olddata) { //更新GMSJ
                var ZXRQ = new Date(this.JLSJ);
                if (this.JCZQId != "0.5")
                    this.GMSJ = this.$format(ZXRQ.setFullYear(ZXRQ.getFullYear() + Number(this.JCZQId)), 'YYYY-MM-DD');
                else
                    this.GMSJ = this.$format(ZXRQ.setMonth(ZXRQ.getMonth() + 6), 'YYYY-MM-DD');
            },
            JCZQId(newdata, olddata) {
                var ZXRQ = new Date(this.JLSJ);
                if (this.JCZQId != "0.5")
                    this.GMSJ = this.$format(ZXRQ.setFullYear(ZXRQ.getFullYear() + Number(this.JCZQId)), 'YYYY-MM-DD');
                else
                    this.GMSJ = this.$format(ZXRQ.setMonth(ZXRQ.getMonth() + 6), 'YYYY-MM-DD');
            }
        },
    };
</script>

<style scoped lang="scss">
    .box {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 34px 40px 0;
        box-sizing: border-box;
        margin-bottom: 20px;
    }

    .title {
        color: $TEXT-DARK-COLOR;
        font-size: 34px;
        font-weight: bold;
    }

    .equipment {
        height: 424px;

        img {
            width: 150px;
            height: 150px;
        }

        .equipment-details {
            display: flex;
            margin-top: 24px;

            &>div {
                margin-left: 34px;
                display: flex;

                div {
                    &:first-child {
                        color: #999;
                        line-height: 55px;
                    }

                    &:last-child {
                        color: #333;
                        line-height: 55px;

                        p {
                            width: 280px;
                            font-size: 29px;
                            color: #333;
                        }
                    }
                }
            }
        }

        &>div:last-child {
            display: flex;
            border-top: 2px solid #f3f3f3;
            margin-top: 20px;

            div {
                flex: 1;
                text-align: left;
                height: 66px;
                line-height: 66px;
                font-size: 29px;
                color: #999;

                &:first-child {
                    border-right: 2px solid #f3f3f3;
                }
            }
        }
    }

    .accessories {
        .title {
            margin-bottom: 10px;
        }

        .check-box {
            display: flex;
            height: 112px;
            border-bottom: 2px solid #f3f3f3;

            &:last-child {
                border: none;
            }

            .van-checkbox {
                flex: 1;
            }
        }
    }

    .borrow {
        .title {
            margin-bottom: 10px;
        }
    }

    .explain {
        input {
            width: 100%;
            text-align: left;
            margin: 20px 0 48px;
        }
    }

    input {
        width: 150px;
        font-size: 29px;
        text-align: center;
        color: #858585;

        &::-webkit-input-placeholder {
            color: #858585;
        }
    }

    textarea {
        font-size: 30px;
        width: 100%;
        border: none;
        margin: 0;
        padding: 20px 0;

        &::-webkit-input-placeholder {
            color: #858585;
        }
    }


    .itemBottomBox {
        margin-top: 32px;
        display: flex;
        align-items: center;
        justify-content: center;

        div {
            width: 95%;
            height: 80px;
            border-radius: 8px;
            text-align: center;
            line-height: 80px;
            font-size: 26px;

            &:last-child {
                background: $THEME-COLOR;
                color: #fff;
            }
        }
    }

    .itemBottomBox2 {

        margin-top: 32px;
        display: flex;
        align-items: center;
        justify-content: center;

        div {
            margin: 0 3vw;
            width: 90%;
            height: 80px;
            border-radius: 8px;
            text-align: center;
            line-height: 80px;
            font-size: 26px;
            background: $THEME-COLOR;
            color: #fff;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/Metering/MeteringDetail.vue